import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FreeMode } from 'swiper/modules';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { styleHandling } from '../../js/styleHandling';
import { setSelectedStyleID } from '../../redux-tool/slice/toolSlice';
import '../styles/Style.css';

export function Style({ styles, styleIndex, handleStyleIndex }) {
  const dispatch = useDispatch();
  const { selectedStyleID } = useSelector((state) => state.tool);
  const slides = [...(Array.isArray(styles) ? styles : [])].filter(() => true);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  const applyStyleSafely = (style) => {
    if (!style || !style.Id || !style.main_texture || window.currentAppliedStyleId === style.Id)
      return;

    if (styleHandling) {
      styleHandling.applyStyleToAllSections(style);
      window.currentAppliedStyleId = style.Id;
    }
  };

  useEffect(() => {
    if (styleIndex !== undefined && swiperRef.current) {
      let selectedStyleIndex = styleIndex;
      if (window.currentStyle?.Id) {
        const foundIndex = slides.findIndex((item) => item.Id === window.currentStyle.Id);
        if (foundIndex !== -1) {
          selectedStyleIndex = foundIndex;
        }
      }
      // Điều khiển slide active khi styleIndex thay đổi
      swiperRef.current.slideTo(selectedStyleIndex, 500);
      setActiveIndex(selectedStyleIndex);

      const selectedStyle = slides[selectedStyleIndex];
      if (selectedStyle && selectedStyle.main_texture && styleHandling) {
        applyStyleSafely(selectedStyle);
      }
    }
  }, [styleIndex, slides]);

  useEffect(() => {
    const styleIndex = slides.findIndex((item) => item.Id === selectedStyleID);
    handleStyleIndex(styleIndex);
  }, [selectedStyleID]);

  return (
    <SwiperComponent
      slidesPerView="auto"
      spaceBetween={10}
      freeMode={true}
      modules={[FreeMode]}
      className="style-swiper-mobile"
      onSwiper={(swiperInstance) => {
        swiperRef.current = swiperInstance;
        swiperInstance.slideTo(styleIndex, 0);
      }}
    >
      {slides?.map((item, index) => (
        <SwiperSlide
          key={index}
          className="custom-slide"
          onClick={() => {
            handleStyleIndex(index);
            setActiveIndex(index);
            dispatch(setSelectedStyleID(String(item.Id)));
            styleHandling.updateUndoStyle(item);
            applyStyleSafely(item);
          }}
        >
          <img
            src={item.Thumbnail}
            className={`style-img ${activeIndex === index ? 'active' : ''}`}
            alt={`Design ${index + 1}`}
          />
        </SwiperSlide>
      ))}
    </SwiperComponent>
  );
}
